export default "__VITE_ASSET__tCYxi11q__"